import { useEffect, useState } from "react";
import classNames from "classnames";
import { TextIcon, Typography } from "components/atoms";
import "./index.scss";

interface IProps {
  textIconLabel: string;
  iconType: undefined | "yellow-timer" | "select" | "empty-circle" | "lock";
  middleLabel?: string;
  isCustom?:boolean;
  theme:"light"|"dark"
}

export const MobileTextIcon = ({
  textIconLabel,
  iconType,
  middleLabel,
  isCustom=false,
  theme
}: IProps) => {
  const [middleText, setMiddleText] = useState("");

  useEffect(() => {
    if (middleLabel) {
      if (middleLabel.length > 8) {
        setMiddleText(middleLabel.slice(0, 5) + "...");
      } else {
        setMiddleText(middleLabel);
      }
    } else {
      setMiddleText("");
    }
  }, []);

  return (
    <div className={classNames("mobile-text-icon-wrapper")}>
      <div className="text-icon-section">
        <TextIcon
          label={textIconLabel}
          icon={true}
          isReverse={true}
          iconType={iconType}
          isTabStyle={true}
          styles={isCustom ? "required-custom-text-style":"custom-text-style"}
          theme={theme}
        />
      </div>

      {middleLabel && (
        <div className="middle-text-section">
          <Typography
            variant="h8Italic"
            label={middleText}
            styles="custom-middle-practice-mobile-style"
          />
        </div>
      )}
    </div>
  );
};